// Use https://www.minifier.org/ to minify the widget.css file in public folder
const baseStyles =
  "seez-sdk-seezar{position:fixed;z-index:10000;display:flex;gap:16px;height:fit-content;flex-direction:column-reverse;margin-block:auto}.topLeft seez-sdk-seezar,.topRight seez-sdk-seezar{flex-direction:column}seez-sdk-seezar>button{display:block;height:60px;width:60px;border:none;cursor:pointer}seez-sdk-seezar>.seeztip{box-shadow:0 .125em .25em #0000002e;width:230px;color:#000;padding:8px 12px;margin-block:0;border-radius:6px;list-style:none;font-size:12.8px}seez-sdk-seezar>.seeztip>img{display:inline;height:32px;vertical-align:middle;margin-inline-end:8px}seez-sdk-seezar>.seeztip>b{vertical-align:middle}seez-sdk-seezar>.seeztip>p{margin-block:8px 0}seez-sdk-seezar>.seeztip>button{margin:0;padding:0;background:none;border:none;cursor:pointer;float:right}seez-sdk-seezar>.seeztip>li{margin-block:16px;cursor:pointer;max-width:20em}seez-sdk-seezar>.seeztip>li::after{content:'\u27A4';float:right;margin-inline-start:16px}seez-sdk-seezar>.seeztip>li:last-child{margin-block-end:0}seez-sdk-seezar>.seeztip>li:first-child{margin-block-start:0}seez-sdk-seezar.open>.seeztip{display:none}.expand{animation:expandAndShrink 2s ease-in-out normal}@keyframes expandAndShrink{0%,100%{transform:scale(1);opacity:1}50%{transform:scale(1.3);opacity:1}}.shakeHorizontal{animation:shake 2s ease-in-out}@keyframes shake{0%,100%{translate:0}10%,30%,50%,70%,90%{translate:-10px 0}20%,40%,60%,80%{translate:10px 0}}.shakeVertical{animation:shakeAt45Degrees 2.5s ease-in-out normal}@keyframes shakeAt45Degrees{0%,100%{transform:rotate(0deg) translate(0,0)}10%,30%,50%,70%,90%{transform:rotate(-45deg) translate(-5px,5px)}20%,40%,60%,80%{transform:rotate(45deg) translate(5px,-5px)}}.bounce{animation:bounce 2s ease-in-out normal}@keyframes bounce{0%,20%,50%,80%,100%{transform:translateY(0)}40%{transform:translateY(-30px)}60%{transform:translateY(-15px)}}.pulse{animation:pulse 2s ease-in-out normal}@keyframes pulse{0%{transform:scale(1)}50%{transform:scale(1.05)}100%{transform:scale(1)}}.swing{animation:swing 2s ease-in-out normal}@keyframes swing{20%{transform:rotate(80deg)}40%{transform:rotate(-40deg)}60%{transform:rotate(80deg)}80%{transform:rotate(-40deg)}100%{transform:rotate(0deg)}}.flip{animation:flip 2s ease-in-out normal}@keyframes flip{0%{transform:rotateY(0)}50%{transform:rotateY(180deg)}100%{transform:rotateY(0)}}"

export default class SeezarButton extends HTMLElement {
  #closeFunction = null
  #config = {}
  #button = null
  #isOpen = false
  #welcome = null
  #sampleQuestions = null
  #dialogStyles = null
  #currentSessionId = sessionStorage.getItem('Seez-Session-Id')
  #lastSessionId = localStorage.getItem('Last-Session-Id')
  #isNewSession = this.#lastSessionId != this.#currentSessionId
  #botId = window.seezSdk.targetSite?.botsRoutes?.find(r => new RegExp(r[0], 'g').test(window.location.href))?.[1]
  #hideWidget = null
  #featureEnabledOn = {}

  constructor() {
    super()

    this.#fetchConfig().then(() => {
      this.#button = document.createElement('button')
      this.#button.onclick = this.#click.bind(this)
      this.#applyConfig()
      this.#setOpenChatFunction()
      this.#getChatStatus()
    }).catch(e => console.error(e))
  }

  #applyConfig() {
    const ca = this.#config.customAttributes
    this.#hideWidget = ca?.find(a => a.key === 'hideWidget')?.value == 'true'
    const f = ca?.find(a => a.key === 'featureEnabledOn')?.value
    try {
      this.#featureEnabledOn = JSON.parse(f)
    } catch (e) {
      console.log('Error parsing json', e)
      this.#featureEnabledOn = {} 
    }
    this.#applyStyles()
    this.appendChild(this.#button)
    requestAnimationFrame(() => window.dispatchEvent(new CustomEvent('track', { detail: { properties: { details: { seez_name: 'widget_loaded', event_owner: 'seez', url: location.href, path: location.pathname + location.search, ref: document.referrer || null, sid: this.#currentSessionId, welcome_message: this.#welcome?.querySelector('p')?.textContent || null } } } })))
    const autostartTime = parseInt(ca?.find(a => a.key === 'chatStartTime')?.value) || 5
    const autoStartChat = ca?.find(a => a.key === 'automatedChatStart')?.value?.toLowerCase() === 'true'
    if (this.#isNewSession && this.#isFeatureEnabled(autoStartChat, this.#featureEnabledOn?.automatedChatStart?.screenSize)) {
      setTimeout(() => this.#click(true), autostartTime * 1000)
      this.#dispatchChatEvent('track', { detail: { properties: { details: { seez_name: 'automatic_chat_start', event_owner: 'seez', path: location.pathname + location.search, ref: document.referrer || null } } } })
    }

    if (!this.#hideWidget) {
      const sqEnabled = this.#featureEnabledOn?.sampleQuestions ?? {}
      if (this.#config.sampleQuestions?.length && this.#isNewSession && this.#isFeatureEnabled(sqEnabled.enabled, sqEnabled.screenSize)) {
        this.#sampleQuestions = document.createElement('ul')
        this.#sampleQuestions.className = 'seeztip sampleQuestions'
        this.#config.sampleQuestions.forEach(q => {
          if (q) {
            const li = document.createElement('li')
            li.textContent = q
            li.onclick = () => window.seezSdk.openChat(q)
            this.#sampleQuestions.appendChild(li)
          }
        })
        Object.assign(this.#sampleQuestions.style, { background: this.#config.avatarBgColor })

        if (this.#sampleQuestions.children.length) this.appendChild(this.#sampleQuestions)
      }

      const wmEnabled = this.#featureEnabledOn?.welcomeMessage ?? {}
      if (this.#config.welcomeMessage && this.#isNewSession && this.#isFeatureEnabled(wmEnabled.enabled, wmEnabled.screenSize)) {
        this.#welcome = document.createElement('div')
        this.#welcome.className = 'seeztip'
        this.#welcome.innerHTML = `<img src="${import.meta.env.VITE_SEEZ_BASE_URL}/image/0x0/${this.#config.botAvatarImage}.webp" />
          <b>${this.#config.botName || 'Seezar'}</b>
          <button id='seez-close-tooltip'>&#x2715;</button>
          <p>${this.#config.welcomeMessage}</p>`
        this.#welcome.onclick = () => window.seezSdk.openChat()
        Object.assign(this.#welcome.style, { background: this.#config.avatarBgColor })

        this.appendChild(this.#welcome)
        this.#welcome.querySelector('#seez-close-tooltip').addEventListener('click', this.#removeTooltips.bind(this))
      }
    }
  }

  #setOpenChatFunction() {
    window.seezSdk.openChat = async (message = '', meta = {}) => {
      const eventType = 'externallyOpenChatModal'
      const eventData = { detail: { message, meta } }

      if (!this.#closeFunction) {
        await this.#click(true)
        setTimeout(() => {
          this.#dispatchChatEvent(eventType, eventData)
        }, 2000) // waiting for the chat compponent to mount
      } else {
        this.#dispatchChatEvent(eventType, eventData)
      }
    }
  }

  #dispatchChatEvent(type, options) {
    const event = new CustomEvent(type, options)
    window.dispatchEvent(event)
  }

  async #click(open) {
    if (typeof open === 'boolean' && open === this.#isOpen) return
    this.#isOpen = typeof open === 'boolean' ? open : !this.#isOpen
    this.#applyStyles()

    if (this.#isOpen) {
      this.classList.add('open')
      const { component, closeFunction } = await window.seezSdk.showComponent('seez-sdk-seezar-chat', { styles: this.#dialogStyles })
      component.addEventListener('closeSeezar', () => this.#click(false))
      this.#closeFunction = closeFunction
      if (this.#isNewSession) this.#removeTooltips()
    } else {
      await this.#closeFunction()
      this.#closeFunction = null
      this.classList.remove('open')
    }
  }

  async #fetchConfig() {
    if (!this.#botId) throw new Error('No bot id found')
    const wcr = await fetch(`${import.meta.env.VITE_SEEZ_BASE_URL}/config/widget/${this.#botId}`)
    if (!wcr.ok) throw new Error(`Failed to fetch bot config "${this.#botId}"`)
    const { config, message } = await wcr.json()
    if (message == 'Bot disabled') {
      throw new Error('Bot is disabled')
    }
    this.#config = config ?? {}
  }

  #applyStyles() {
    const c = this.#config
    const widgetMargins = { marginNone: '0rem ', marginSmall: '0.5rem', marginMedium: '1rem', marginLarge: '2rem', marginExtraLarge: '7rem' }
    const customCss = JSON.parse(c.customCss || '{}')
    const wm = widgetMargins[customCss?.widgetMargin ?? 'marginSmall']
    const wa = customCss?.widgetAnimation || 'none'
    if (wa !== 'none') this.#button.classList.add(wa)

    this.classList.add(c.widgetPosition)
    Object.assign(this.style, {
      insetInline: c.widgetPosition?.endsWith('Left') ? `${wm} auto` : `auto ${wm}`,
      insetBlock: this.#isOpen || c.widgetPosition?.startsWith('bottom') ? `auto ${wm}` : c.widgetPosition?.startsWith('top') ? `${wm} auto` : '50%'
    })

    const iconUrl = this.#isOpen ? `data:image/svg+xml,<svg viewBox="0 0 12 7" stroke="${c.widgetIconTheme == 'light' ? 'white' : 'black'}" xmlns="http://www.w3.org/2000/svg"><path d="M10 2 6 6M2 2 6 6" stroke-width="1" stroke-linecap="round" /></svg>` : `https://platform.seez.dev/image/0x0/${c.widgetIcon}.webp`

    Object.assign(this.#button.style, {
      marginInline: 'auto 0',
      borderRadius: c.borderRadius === 'rounded' ? '48px' : '6px',
      background: `${c.primaryColor} url('${iconUrl}') no-repeat center center`,
      backgroundSize: '32px',
      display: this.#hideWidget && !this.#isOpen ? 'none' : 'block'
    })

    this.#dialogStyles = {
      'insetInline': this.style.insetInline,
      'insetBlock': `auto calc(${wm} + 1rem + 64px)`,
      'border': 'none',
      'background': 'none',
      'padding': 0,
      'position': 'fixed',
      'z-index': 10000
    }

    if (!document.head.querySelector('#seez-sdk-seezar-widget-styles')) {
      const bs = document.createElement('style')
      bs.textContent = baseStyles
      bs.id = 'seez-sdk-seezar-widget-styles'
      document.head.appendChild(bs)
    }
  }

  #removeTooltips(e) {
    e?.stopPropagation()
    this.#welcome?.remove()
    this.#sampleQuestions?.remove()
    this.#setLastSessionId()
    if (e && e.isTrusted) this.#dispatchChatEvent('track', { detail: { properties: { details: { seez_name: 'tooltip_close', event_owner: 'seez', path: location.pathname + location.search, ref: document.referrer || null } } } })
  }

  #setLastSessionId() {
    this.#lastSessionId = this.#currentSessionId
    localStorage.setItem('Last-Session-Id', this.#lastSessionId)
    this.#isNewSession = false
  }

  #isFeatureEnabled(enabled, screenSize) {
    if (!enabled) return false
    if (screenSize == 'both') return true

    const currentScreenSize = window.innerWidth > 768 ? 'desktop' : 'mobile'
    return currentScreenSize === screenSize
  }

  async #getChatStatus() {
    if (localStorage.getItem('Handover-State') == 'agentAssigned') this.#click(true)
  }
}
